
export enum Modality {
	Monthly = 'Monthly',
	Annually = 'Yearly',
}
